<form [formGroup]="form" class="form">
    <kt-form-tab-header
        [headers]="(formTabHeaders$|async)!"
        (tabChange)="onTabChange($event)"
    ></kt-form-tab-header>

    <mat-tab-group class="invinsible-tabs" [selectedIndex]="selectedTab">
        <mat-tab>
            <div class="card-body pt-0 mad-container">
                <app-comparable-location
                    [centerLatitude]="centerLat"
                    [centerLongitude]="centerLng"
                    [locationInfo]="locationData$|async"
                    (centerChange)="onCenterChange($event)"
                    (markerChange)="onMarkerChangeV2($event)"
                ></app-comparable-location>
                <app-parcel-identification
                    *ngIf="isComplexForm$|async"
                    class="section-margin-top-60"
                    [form]="form.controls.parcel_identification"
                    [centerLat]="centerLat"
                    [centerLng]="centerLng"
                    [coordinatePoints]="coordinatePoints$|async"
                    [landAreas]="landAreas$|async"
                    [marker]="markerInfo$|async"
                    (coordinatePointsChange)="onCoordinatePointsChange($event)"
                    (landAreasChange)="onLandAreasChange($event)"
                ></app-parcel-identification>
            </div>
        </mat-tab>

        <mat-tab>
            <div class="card-body pt-0 mad-container">
                <div class="form-group row">
                    <div class="col-lg-12">
                        <h5 class="my-3 text-mad text-uppercase">About the Hotel</h5>
                        <hr class="active" />
                    </div>

                    <div class="col-lg-4">
                        <mat-form-field class="mat-form-field-fluid" [formFieldState]="form.controls.property_type_id">
                            <mat-select placeholder="Hotel Type" formControlName="property_type_id">
                                <mat-option *ngFor="let option of (hotelTypes$|async)"
                                    [value]="option.id"
                                >
                                    {{ option.name }}
                                </mat-option>
                            </mat-select>
                            <mat-hint [formFieldHintState]="form.controls.property_type_id">
                                Hotel type <span>required</span>
                            </mat-hint>
                            <mat-error>
                                Hotel type <strong>required</strong>
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="col-lg-4" *ngIf="form.controls.property_type_id.value === HotelTypes.Hotel">
                        <mat-form-field class="mat-form-field-fluid" [formFieldState]="form.controls.hotel_rating_id">
                            <mat-select placeholder="Hotel Rating" formControlName="hotel_rating_id">
                                <mat-option *ngFor="let option of (hotelRatings$|async)"
                                    [value]="option.id"
                                >
                                    {{ option.name }}
                                </mat-option>
                            </mat-select>
                            <mat-hint [formFieldHintState]="form.controls.hotel_rating_id">
                                Hotel rating <span>required</span>
                            </mat-hint>
                            <mat-error>
                                Hotel rating <strong>required</strong>
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="col-lg-4" *ngIf="form.controls.property_type_id.value === HotelTypes.HotelApartments">
                        <mat-form-field class="mat-form-field-fluid" [formFieldState]="form.controls.hotel_apartment_rating_id">
                            <mat-select placeholder="Hotel Rating" formControlName="hotel_apartment_rating_id">
                                <mat-option *ngFor="let option of (hotelApartmentRatings$|async)"
                                    [value]="option.id"
                                >
                                    {{ option.name }}
                                </mat-option>
                            </mat-select>
                            <mat-hint [formFieldHintState]="form.controls.hotel_rating_id">
                                Hotel rating <span>required</span>
                            </mat-hint>
                            <mat-error>
                                Hotel rating <strong>required</strong>
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="col-lg-4">
                        <mat-form-field class="mat-form-field-fluid">
                            <input matInput formControlName="completion_status" placeholder="Completion Status" />
                        </mat-form-field>
                    </div>

                    <div class="col-lg-4">
                        <mat-form-field class="mat-form-field-fluid">
                            <span (click)="completionDatePicker.open()">
                                <input matInput readonly placeholder="Completion Date" 
                                    formControlName="completion_date" 
                                    [matDatepicker]="completionDatePicker"
                                />
                            </span>
                            <mat-datepicker-toggle matSuffix [for]="completionDatePicker"></mat-datepicker-toggle>
                            <button mat-icon-button matSuffix matTooltip="Clear" 
                                type="button"
                                *ngIf="form.controls.completion_date.value"
                                (click)="onClearCompletionDate()"
                            >
                                <mat-icon>close</mat-icon>
                            </button>
                            <mat-datepicker #completionDatePicker></mat-datepicker>
                        </mat-form-field>
                    </div>

                    <div class="col-lg-4">
                        <mat-form-field class="mat-form-field-fluid">
                            <input matInput formControlName="estimated_age" placeholder="Estimated Age (years)" 
                                mask="separator"
                            />
                        </mat-form-field>
                    </div>

                    <div class="col-lg-4 d-flex align-items-center justify-content-between">
                        <span>Estimated Remaining Lifespan (years)</span>
                        <div class="d-flex align-items-center" style="gap: 0.5rem;">
                            <mat-form-field style="width: 5rem;" >
                                <input matInput formControlName="estimated_remaining_lifespan_from" placeholder="From" mask="separator" />
                            </mat-form-field>
                            <span>-</span>
                            <mat-form-field style="width: 5rem;">
                                <input matInput formControlName="estimated_remaining_lifespan_to" placeholder="To" mask="separator" />
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="col-lg-4">
                        <mat-form-field class="mat-form-field-fluid">
                            <input matInput formControlName="developer" placeholder="Developer" />
                        </mat-form-field>
                    </div>

                    <div class="col-lg-4">
                        <mat-form-field class="mat-form-field-fluid">
                            <input matInput formControlName="number_of_stories" placeholder="Number of Stories" />
                        </mat-form-field>
                    </div>

                    <div class="col-lg-4">
                        <mat-form-field class="mat-form-field-fluid">
                            <input matInput formControlName="views" placeholder="Views" />
                        </mat-form-field>
                    </div>

                    <div class="col-lg-4">
                        <mat-form-field class="mat-form-field-fluid">
                            <input matInput formControlName="plot_id" placeholder="Plot ID" />
                        </mat-form-field>
                    </div>

                    <div class="col-lg-4">
                        <mat-form-field class="mat-form-field-fluid">
                            <input matInput formControlName="plot_area" placeholder="Plot Area (sqft)" 
                                mask="separator.2" thousandSeparator=","
                            />
                        </mat-form-field>
                    </div>
                </div>

                <div class="row">
                    <div class="col-lg-4">
                        <mat-form-field class="mat-form-field-fluid">
                            <input matInput formControlName="makani_no" placeholder="Makani Number" />
                        </mat-form-field>
                    </div>

                    <div class="col-lg-4">
                        <mat-form-field class="mat-form-field-fluid">
                            <input matInput formControlName="dewa_no" placeholder="DEWA No" />
                        </mat-form-field>
                    </div>

                    <div class="col-lg-4">
                        <mat-form-field class="mat-form-field-fluid">
                            <input matInput formControlName="municipality_no" placeholder="Municipality Number" />
                        </mat-form-field>
                    </div>

                    <div class="col-lg-12">
                        <mat-form-field class="mat-form-field-fluid">
                            <textarea matInput formControlName="state_of_repair_desc" placeholder="State of repair description"
                            ></textarea>
                        </mat-form-field>
                    </div>

                    <div class="col-lg-12">
                        <mat-form-field class="mat-form-field-fluid">
                            <textarea matInput formControlName="construction_desc" placeholder="Construction description"
                            ></textarea>
                        </mat-form-field>
                    </div>

                    <div class="col-lg-12">
                        <div class="row">
                            <div class="col-12">
                                <div class="d-flex align-items-center" style="gap: 0.2rem;">
                                    <button type="button" mat-icon-button color="primary" (click)="onAddConstructionCategory()">
                                        <mat-icon>add_circle</mat-icon>
                                    </button>
                                    <span class="font-italic font-weight-bold">
                                        Add a construction category
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <ng-container *ngFor="let group of form.controls.construction_category_form_array.controls; let i = index">
                                <div class="col-6" [formGroup]="group">
                                    <div class="row">
                                        <div class="col-10">
                                            <mat-form-field class="mat-form-field-fluid">
                                                <input matInput [placeholder]="'Construction category ' + (i + 1) + ' Title'" formControlName="title" />
                                            </mat-form-field>
                                        </div>
                                        <div class="col-2">
                                            <button type="button" mat-icon-button color="warn" (click)="onRemoveConstructionCategory(i)">
                                                <mat-icon>delete</mat-icon>
                                            </button>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-12">
                                            <mat-form-field class="mat-form-field-fluid">
                                                <textarea matInput formControlName="description" [placeholder]="'Construction category ' + (i + 1) + ' description'"></textarea>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                    </div>

                    <div class="col-12 mt-10">
                        <div class="row">
                            <div class="col-4">
                                <mat-form-field class="mat-form-field-fluid" [formFieldState]="form.controls.upgrades_condition_id">
                                    <mat-select placeholder="Upgrades & Special conditions" formControlName="upgrades_condition_id">
                                        <mat-option [value]="1">Fully upgraded</mat-option>
                                        <mat-option [value]="2">Partially upgraded</mat-option>
                                        <mat-option [value]="3">None</mat-option>
                                    </mat-select>
                                    <mat-hint [formFieldHintState]="form.controls.upgrades_condition_id">
                                        Upgrades & Special conditions <span>required</span>
                                    </mat-hint>
                                    <mat-error>
                                        Upgrades & Special conditions <strong>required</strong>
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            <div class="col-2">
                                <button type="button" mat-icon-button color="primary" (click)="onAddUpgradesAndSpecialCondition()">
                                    <mat-icon>add_circle</mat-icon>
                                </button>
                            </div>
                        </div>
                        <div class="row" *ngFor="let control of form.controls.upgrades_conditions_form_array.controls; let i = index">
                            <div class="col-4">
                                <mat-form-field class="mat-form-field-fluid" [formFieldState]="control">
                                    <input matInput [placeholder]="'Upgrades & Special conditions ' + (i + 1)" [formControl]="control" />
                                    <mat-hint [formFieldHintState]="control">
                                        <span>Required</span>
                                    </mat-hint>
                                    <mat-error>
                                        <strong>Required</strong>
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            <div class="col-2">
                                <button type="button" mat-icon-button color="warn" (click)="onRemoveUpgradesAndSpecialCondition(i)">
                                    <mat-icon>delete</mat-icon>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="form-group row">
                    <div class="col-12">
                        <h6 class="my-3 font-weight-bold">Hotel Accommodation</h6>
                    </div>

                    <input #hotelAccommodationFileInput type="file" hidden accept=".csv" 
                        (change)="onUploadHotelAccommodationFile($event)"
                    />
                    <div class="col-12 d-flex align-items-center mt-2" style="gap: 1rem;">
                        <button type="button" mat-raised-button color="primary"
                            (click)="onClickUploadHotelAccommodation()"
                        >
                            Upload CSV
                        </button>
                        <ng-container *ngIf="hotelAccommodationFile$|async as viewModel">
                            <div class="d-flex align-items-center" style="gap: 0.5rem">
                                <button type="button" mat-icon-button color="primary" *ngIf="viewModel.isUploaded">
                                    <mat-icon>remove_red_eye</mat-icon>
                                </button>
                                <div>
                                    <span class="font-weight-bold">File name: </span>
                                    <ng-container *ngIf="viewModel.file">
                                        <span style="color: green">{{viewModel.file.display_name}}</span>
                                    </ng-container>
                                    <ng-container *ngIf="!viewModel.file">
                                        <span style="color: red">N/A</span>
                                    </ng-container>
                                </div>
                            </div>
                        </ng-container>
                    </div>

                    <div class="col-12 mt-2">
                        <span class="font-italic">
                            Please upload the CSV file of your hotel accommodation. The table in your CSV file should not be wider than 10 columns. Do not use horizontal merged cells in the table as this may impact the conversion process.
                        </span>
                    </div>
                </div>

                <div class="form-group row">
                    <div class="col-12">
                        <h6 class="my-3 font-weight-bold">Hotel Room schedule</h6>
                    </div>

                    <div class="col-12 mt-2">
                        <mat-radio-group formControlName="room_schedule_type">
                            <mat-radio-button [value]="'upload'">Upload CSV</mat-radio-button>
                            <mat-radio-button [value]="'table'">Room Schedule Table</mat-radio-button>
                        </mat-radio-group>
                    </div>

                    <ng-container *ngIf="form.controls.room_schedule_type.value === 'upload'">
                        <div class="col-4 mt-2">
                            <mat-form-field class="mat-form-field-fluid" [formFieldState]="form.controls.number_of_units">
                                <input matInput placeholder="Number of units" formControlName="number_of_units" />
                                <mat-hint [formFieldHintState]="form.controls.number_of_units">
                                    Number of units <span>required</span>
                                </mat-hint>
                                <mat-error>
                                    Number of units <strong>required</strong>
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <input #roomScheduleFileInput type="file" hidden accept=".csv" 
                            (change)="onUploadRoomScheduleFile($event)"
                        />
                        <div class="col-12 d-flex align-items-center mt-2" style="gap: 1rem;">
                            <button type="button" mat-raised-button color="primary"
                                (click)="onClickUploadRoomSchedule()"
                            >
                                Upload CSV
                            </button>
                            <ng-container *ngIf="roomScheduleFile$|async as viewModel">
                                <div class="d-flex align-items-center" style="gap: 0.5rem">
                                    <button type="button" mat-icon-button color="primary" *ngIf="viewModel.isUploaded">
                                        <mat-icon>remove_red_eye</mat-icon>
                                    </button>
                                    <div>
                                        <span class="font-weight-bold">File name: </span>
                                        <ng-container *ngIf="viewModel.file">
                                            <span style="color: green">{{viewModel.file.display_name}}</span>
                                        </ng-container>
                                        <ng-container *ngIf="!viewModel.file">
                                            <span style="color: red">N/A</span>
                                        </ng-container>
                                    </div>
                                </div>
                            </ng-container>
                        </div>

                        <div class="col-12 mt-2">
                            <span class="font-italic">
                                Please upload the CSV file of your hotel room schedule. The table in your CSV file should not be wider than 10 columns. Do not use horizontal merged cells in the table as this may impact the conversion process.
                            </span>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="form.controls.room_schedule_type.value === 'table'">
                        <div class="col-6 mt-4">
                            <table class="room-schedule-table table">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Room type</th>
                                        <th>No.</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <ng-container *ngFor="let group of form.controls.room_schedule_form_array.controls; let i = index">
                                        <tr [formGroup]="group">
                                            <td>{{ i + 1 }}</td>
                                            <td>
                                                <input formControlName="room_type" placeholder="Room type" />
                                            </td>
                                            <td>
                                                <input formControlName="number" placeholder="Number" mask="separator" />
                                            </td>
                                            <td>
                                                <div class="d-flex">
                                                    <button type="button" mat-icon-button color="primary"
                                                        (click)="onAddRoomSchedule()"
                                                    >
                                                        <mat-icon>add_circle</mat-icon>
                                                    </button>
                                                    <button type="button" mat-icon-button color="warn" *ngIf="form.controls.room_schedule_form_array.controls.length != 1"
                                                        (click)="onRemoveRoomSchedule(i)"
                                                    >
                                                        <mat-icon>delete</mat-icon>
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    </ng-container>
                                    <tr>
                                        <td colspan="2">Total</td>
                                        <td>
                                            {{ totalRoomSchedule$|async }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </ng-container>
                </div>

                <div class="form-group row">
                    <div class="col-12">
                        <h6 class="my-3 font-weight-bold">Outlets / Facilities</h6>
                    </div>

                    <input #outletsFileInput type="file" hidden accept=".csv" 
                        (change)="onUploadOutletsFile($event)"
                    />
                    <div class="col-12 d-flex align-items-center mt-2" style="gap: 1rem;">
                        <button type="button" mat-raised-button color="primary"
                            (click)="onClickUploadOutlets()"
                        >
                            Upload CSV
                        </button>
                        <ng-container *ngIf="outletsFile$|async as viewModel">
                            <div class="d-flex align-items-center" style="gap: 0.5rem">
                                <button type="button" mat-icon-button color="primary" *ngIf="viewModel.isUploaded">
                                    <mat-icon>remove_red_eye</mat-icon>
                                </button>
                                <div>
                                    <span class="font-weight-bold">File name: </span>
                                    <ng-container *ngIf="viewModel.file">
                                        <span style="color: green">{{viewModel.file.display_name}}</span>
                                    </ng-container>
                                    <ng-container *ngIf="!viewModel.file">
                                        <span style="color: red">N/A</span>
                                    </ng-container>
                                </div>
                            </div>
                        </ng-container>
                    </div>

                    <div class="col-12 mt-2">
                        <span class="font-italic">
                            Please upload the CSV file of your hotel outlets/facilities. The table in your CSV file should not be wider than 10 columns. Do not use horizontal merged cells in the table as this may impact the conversion process.
                        </span>
                    </div>
                </div>

                <div class="form-group row section-margin-top-60">
                    <div class="col-lg-12">
                        <h5 class="my-3 text-mad text-uppercase">Services and Infrastructures</h5>
                        <hr class="active" />
                    </div>

                    <div class="col-lg-12">
                        <kt-services-and-infrastructures
                            [isComplexForm]="isComplexForm$|async"
                            [serviceAndInfraData]="serviceAndInfraData$|async"
                            [propertySubTypeID]="HotelAssetClassTypeID"
                        ></kt-services-and-infrastructures>
                    </div>
                </div>

                <div class="form-group row section-margin-top-60">
                    <div class="col-lg-12">
                        <h5 class="my-3 text-mad text-uppercase">External Aspect</h5>
                        <hr class="active" />
                    </div>

                    <div class="col-lg-12">
                        <kt-external-aspects
                            [propertySubTypeID]="HotelAssetClassTypeID"
                            [formType]="'comparable'"
                            [externalAspectData]="externalAspectData$|async"
                        ></kt-external-aspects>
                    </div>
                </div>

                <div class="form-group row section-margin-top-60">
                    <div class="col-lg-12">
                        <h5 class="my-3 text-mad text-uppercase">Internal Aspect</h5>
                        <hr class="active" />
                    </div>

                    <div class="col-lg-12">
                        <kt-internal-aspects
                            [propertySubTypeID]="HotelAssetClassTypeID"
                            [formType]="'comparable'"
                            [internalAspectData]="internalAspectData$|async"
                        ></kt-internal-aspects>
                    </div>
                </div>

                <div class="form-group row section-margin-top-60">
                    <div class="col-lg-12">
                        <h5 class="my-3 text-mad text-uppercase">Grounds</h5>
                        <hr class="active" />
                    </div>

                    <div class="col-lg-12">
                        <kt-ac-grounds
                            [isComplexForm]="isComplexForm$|async"
                            [propertySubTypeID]="HotelAssetClassTypeID"
                            [initData]="groundsData$|async"
                        ></kt-ac-grounds>
                    </div>
                </div>

                <kt-ac-size class="section-margin-top-60" 
                    [sizesSubject]="sizesSubject$"
                    [assetClassType]="HotelAssetClassTypeIDStr"
                ></kt-ac-size>
                <mat-error 
                    errorStateWithLength
                    [hasFormError]="hasFormErrors"
                    [isInValid]="sizesSubject$.value.length === 0"
                    [innerHtml]="'GENERAL.VALIDATION.REQUIRED' | translate:{
                        field: ('RETAIL_SHOP.FORM.FIELD.SIZES.SECTION_TITLE' | translate)
                    }"
                >
                </mat-error>
                <div class="row">
                    <div class="col-12">
                        <h5 class="font-weight-bold">Floor area measurement</h5>
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col-12">
                        <mat-form-field class="mat-form-field-fluid">
                            <textarea matInput formControlName="floor_area_measurement_comment" placeholder="Floor area measurement comment"></textarea>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col-12">
                        <span class="font-italic">
                            Please upload the CSV file of your floor measurement. The table in your CSV file should not be wider than 10 columns. Do not use horizontal merged cells in the table as this may impact the conversion process
                        </span>
                    </div>
                </div>
                <ng-container *ngFor="let group of form.controls.floor_area_measurement_form_array.controls; let i = index">
                    <div class="row mt-2" [formGroup]="group">
                        <div class="col-12 d-flex align-items-center" style="gap: 1rem;">
                            <button type="button" mat-raised-button color="primary" (click)="onClickUploadFloorAreaMeasurement(i)">
                                Upload CSV
                            </button>
                            <div class="d-flex align-items-center" style="gap: 0.5rem;">
                                <button type="button" mat-icon-button color="primary" *ngIf="group.controls.name.value">
                                    <mat-icon>remove_red_eye</mat-icon>
                                </button>
                                <div>
                                    <span class="font-weight-bold">File name: </span>
                                    <ng-container *ngIf="group.controls.name.value">
                                        <span style="color: green">{{group.controls.display_name.value}}</span>
                                    </ng-container>
                                    <ng-container *ngIf="!group.controls.name.value">
                                        <span style="color: red">N/A</span>
                                    </ng-container>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 mt-2">
                            <div class="row">
                                <div class="col-4">
                                    <mat-form-field class="mat-form-field-fluid">
                                        <input matInput formControlName="title"
                                            [placeholder]="'Table ' + (i + 1) + ' Title'" />
                                    </mat-form-field>
                                </div>
                                <div class="col-4">
                                    <mat-form-field class="mat-form-field-fluid">
                                        <mat-select formControlName="property_sub_type_id"
                                            placeholder="Property Sub-type">
                                            <mat-option *ngFor="let option of propertySubTypes$|async" [value]="option.id">
                                                {{ option.name }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                                <div class="col-4">
                                    <ng-container *ngIf="measurementStandards$|async as ms">
                                        <mat-form-field class="mat-form-field-fluid">
                                            <mat-select formControlName="measurement_standard_id" placeholder="Measurement Standard">
                                                <mat-option *ngFor="let option of filterMeasurementStandards(i, ms)" [value]="option.id">
                                                    {{ option.name }}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </ng-container>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row mt-1">
                        <div class="col-1">
                            <button type="button" mat-icon-button color="primary" (click)="onAddFloorAreaMeasurement()">
                                <mat-icon>add_circle</mat-icon>
                            </button>
                        </div>
                        <div class="col-1" *ngIf="i !== 0">
                            <button type="button" mat-icon-button color="warn" (click)="onRemoveFloorAreaMeasurement(i)">
                                <mat-icon>delete</mat-icon>
                            </button>
                        </div>
                    </div>
                </ng-container>
            </div>
        </mat-tab>

        <mat-tab>
            <kt-esg-indicators 
                formType="comparable" 
                [value]="esgIndicatorData$|async"
                [systemOfMeasurement]="userUnitOfMeasurementId$|async" 
            />
        </mat-tab>

        <mat-tab>
        <div class="card-body pt-0 mad-container">
            <kt-consideration-and-source 
                style="margin-top: 60px;" 
                [inputConsiderations]="tenuresSubject|async"
                [landAreaComponentListSubject]="comps" 
                [hasParcelInfo$]="hasParcel" 
                [timezoneOffset]="timezoneOffset"
                [sizes]="sizes$|async" 
                [propertyType]="HotelAssetClassTypeID"
                [roomScheduleType]="roomScheduleType$|async"
                [roomSchedules]="roomSchedules$|async"
                (considerationsChange)="onConsiderationsChange($event)"
            ></kt-consideration-and-source>
            <mat-error 
                errorStateWithLength 
                [hasFormError]="hasFormErrors" 
                [isInValid]="considerationError$|async">
                Input <strong>required</strong>
            </mat-error>
        </div>
        </mat-tab>

        <mat-tab>
            <div class="card-body pt-0 mad-container">
                <div class="form-group row section-margin-top-60">
                    <div class="col-lg-12">
                        <h5 class="my-3 text-mad text-uppercase">
                            Property Pictures
                        </h5>
                        <hr class="active">
                    </div>

                    <kt-upload-file #simple class="col-lg-12" 
                        [filesOnEditMode]="acPictures$|async"
                        [folderOnEditMode]="picture$|async" 
                        [readOnly]="false" [parentForm]="'hotel'" [typeField]="false"
                        fileType="image/*" split="1" [featuredPictureAllowed]="true" [hasThumbnail]="true"
                        [addButtonLabel]="'Add Picture'">
                    </kt-upload-file>
                </div>

                <kt-ac-document-upload *ngIf="isComplexForm$|async" class="section-margin-top-60" [files]="documents$|async">
                </kt-ac-document-upload>
            </div>
        </mat-tab>
    </mat-tab-group>
</form>